import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spOther";

const SpOtherMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    // --- Payload update logic (mirroring spAddressMapper) ---
    const rawFormValues = {
      title: "Other Change",
      "Details of the Change": data.otherDetails,
    };
    const formValues = Object.fromEntries(
      Object.entries(rawFormValues).filter(
        ([, value]) => value !== undefined && value !== null && value !== ""
      )
    );
    const formattedData = formatData(formValues);

    store.updateField("Other_Changes_Details__c", formattedData);
    store.updateField("Other_Changes__c", true);
    store.updateField(
      "Other_Changes_Effective_From__c",
      formatDateT(data.otherEffectiveDateTime) || ""
    );
  },
};

export default SpOtherMapper;
